import { useState, useEffect } from 'react';
import { emailRegex } from "../../utils/helper.js";
import HeaderNoAuth from "../Navigation/HeaderNoAuth";
import FetchUtil from "../../utils/FetchUtil";
import { useTranslation } from 'react-i18next';

function Signup() {
	const [states, setStates] = useState([]);
	const [countries, setCountries] = useState([]);
	const [error, setError] = useState("");
	const [info, setInfo] = useState("");
	const [formErrors, setFormErrors] = useState([]);
	const [isSubmit, setIsSubmit] = useState(false);
	const [stateValue, setStateValue] = useState("0-");
	const [countrySelected, setCountrySelected] = useState("US");
	const { t } = useTranslation();

	const submitText = t("page.submit");

	const initialValues = {
		email: "",
		firstName: "",
		lastName: "",
		address1: "",
		address2: "",
		phone: "",
		zipCode: "",
		zipExt: "",
		city: "",
		stateKey: 0,
		stateCode: "",
		countryCode: "US",
		companyName: "",
	};
	const [formValues, setFormValues] = useState(initialValues);

	useEffect(() => {
		fetchCountries();
		fetchStates();
	}, []);

	function fetchCountries() {
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web" }),
		};
		try {
			FetchUtil.fetchAPI("GetCountries", "/Service/StaticHelper/GetCountries", requestOptions, getCountriesSuccess, getCountriesFail);
		} catch (error) {
			setError(error.message);
		}
	}

	function getCountriesFail(redirect) {
		setError(t("error.getCountryFailed"));
	}

	function getCountriesSuccess(responseData) {
		var countriesResponse;
		if (responseData) {
			countriesResponse = responseData.getCountriesResponse;
			if (countriesResponse && countriesResponse.errorCode === "0") {
				setCountries([...countries, ...countriesResponse.countries]);
			} else if (countriesResponse) {
				setError(t("error.error") + " " + countriesResponse.errorMessage);
			}
		}
	}
	function fetchStates() {
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web", getAll: true, countryCode: "" }),
		};
		try {
			FetchUtil.fetchAPI("MGetAllState", "/Service/StaticHelper/GetAllState", requestOptions, getStatesSuccess, getStatesFail);
		} catch (error) {
			setError(error.message);
		}
	}
	function getStatesFail(redirect) {
		setError(t("error.getStateFailed"));
	}
	function getStatesSuccess(responseData) {
		let stateResponse;
		if (responseData) {
			stateResponse = responseData.getStateResponse;
			if (stateResponse && stateResponse.errorCode === "0") {
				setStates([...states, ...stateResponse.states]);
			} else if (stateResponse) {
				setError(t("error.error") + " " + stateResponse.errorMessage);
			}
		}
	}

	const valueHandler = (e) => {
		const { name, value } = e.target;
		setFormValues({ ...formValues, [name]: value });
		setInfo("");
	}
	const countryHandler = (e) => {
		let countryCode = e.target.value;
		formValues.countryCode = countryCode;
		setCountrySelected(countryCode);
	}
	const stateHandler = (e) => {
		let state = e.target.value;
		setStateValue(state);
		let stateArr = state.split("-");
		formValues.stateKey = stateArr[0];
		formValues.stateCode = stateArr[1];
	}
	const handleSubmit = (event) => {
		event.preventDefault();
		setInfo("");
		setFormErrors([]);
		setIsSubmit(true);
		const formData = new FormData(event.currentTarget);
		for (let entry of formData.entries()) {
			if (entry[0] === "stateKey") {
				var stateArr = entry[1].split("-");
				formValues[entry[0]] = stateArr[0];
				formValues.stateCode = stateArr[1];

			} else {
				formValues[entry[0]] = entry[1];
			}
		}
		let errors = validateFields();
		setFormErrors(errors);
		if (!errors || errors.length === 0) {
			updateUser();
		} else {
			setIsSubmit(false);
		}

	};
	const validateFields = () => {
		const errors = [];
		if (!formValues.email) {
			errors.push(t("error.emailReqd"));
		} else {
			if (!emailRegex.test(formValues.email.trim())) {
				errors.push(t("error.invalidEmail"));
			}
		}
		let firstName = formValues.firstName;
		if (!firstName || !firstName.trim()) {
			errors.push(t("error.firstNameReqd"));
		}
		let lastName = formValues.lastName;
		if (!lastName || !lastName.trim()) {
			errors.push(t("error.lastNameReqd"));
		}
		let companyName = formValues.companyName;
		if (!companyName || !companyName.trim()) {
			errors.push(t("error.compNameReqd"));
		}
		if (!formValues.stateKey) {
			errors.push(t("error.stateReqd"));
		}
		let phone = formValues.phone;
		if (!phone || !phone.trim()) {
			errors.push(t("error.phoneReqd"));
		}
		return errors;
	};
	const updateUser = () => {
		let serverParams = {
			loginId: formValues.email.trim(),
			email: formValues.email.trim(),
			address1: (formValues.address1) ? formValues.address1.trim() : '',
			address2: (formValues.address2) ? formValues.address2.trim() : '',
			phone: (formValues.phone) ? formValues.phone.trim() : '',
			zipCode: (formValues.zipCode) ? formValues.zipCode.trim() : '',
			zipExt: (formValues.zipExt) ? formValues.zipExt.trim() : '',
			city: (formValues.city) ? formValues.city.trim() : '',
			stateKey: formValues.stateKey,
			stateCode: formValues.stateCode.trim(),
			countryCode: formValues.countryCode,
			source: "web",
			companyName: formValues.companyName.trim(),
			firstName: formValues.firstName.trim(),
			lastName: formValues.lastName.trim()
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("AddUser", "/Service/StaticUserService/InitiateAddUser", requestOptions, addUserSuccess, addUserFail);
		} catch (error) {
			setError(error.message);
			setIsSubmit(false);
		}
	};

	function addUserFail(redirect) {
		setIsSubmit(false);
		setError(t("error.addUserFailed"));
	}
	function addUserSuccess(responseData) {
		setIsSubmit(false);
		let initiateAddUserResponse;
		if (responseData) {
			initiateAddUserResponse = responseData.initiateAddUserResponse;
			if (initiateAddUserResponse) {
				if (initiateAddUserResponse.errorCode === "0") {
					setInfo("iDecisionSciences have been notified about your access request.")
				} else {
					setError(t("error.error") + " " +
						initiateAddUserResponse.errorMessage
					);
				}
			}
		}
	}

	return (
		<>
			<HeaderNoAuth />
			<div id="page">
				<div className="page-inner">
					<div id="main">
						<div className="row">
							<div className="col-md-3 col-sm-3 col-sx-12"></div>
							<div className="col-md-6 col-sm-6 col-sx-12">
								{((formErrors && formErrors.length > 0) || error) && (
									<div id="inerrorMessage" className="errorblock">
										{((formErrors && formErrors.length > 0) || error) ? (
											formErrors.map((errorData, index) => (
												<p className="message-line">{errorData}</p>
											))
										) : ""}
										{error}
									</div>
								)}
								{(info && (
									<div style={{ backgroundColor: "#1d7d16", color: "white" }}>
										<b>{info}</b>
									</div>
								)
								)}
							</div>
						</div>
						<div className="row">
							<div className="col">
								<form
									className="regn_form_container"
									acceptCharset="UTF-8"
									id="sign-up"
									onSubmit={handleSubmit}
								>
									<h2>{t("header.admin.signUp")}
									</h2>
									<div className="row">
										<div className="col">
											<div className="form-group">
												<label htmlFor="email" className="form-label">
													<span className="form_required">*</span>
													{t("page.email")}
												</label>
												<input
													type="text"
													name="email"
													id="email"
													placeholder="Email"
													maxLength="50"
													value={formValues.email}
													onChange={(e) => valueHandler(e)}
													className="form-control rounded-pill border-0 shadow-sm px-4"
												/>
											</div>
										</div>
										<div className="col">
											<div className="form-group">
												<label className="form-label">
													<span className="form_required">*</span>
													{t("page.company")}
												</label>
												<input name="companyName" value={formValues.companyName} maxlength="50"
													className="form-control rounded-pill border-0 shadow-sm px-4"
													onChange={(e) => valueHandler(e)} />
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col">
											<div className="form-group">
												<label className="form-label">
													<span className="form_required">*</span>
													{t("page.firstName")}
												</label>
												<input name="firstName" value={formValues.firstName} maxlength="50"
													className="form-control rounded-pill border-0 shadow-sm px-4"
													onChange={(e) => valueHandler(e)} />
											</div>
										</div>
										<div className="col">
											<div className="form-group">
												<label className="form-label">
													<span className="form_required">*</span>
													{t("page.lastName")}
												</label>
												<input name="lastName" value={formValues.lastName} maxlength="50"
													className="form-control rounded-pill border-0 shadow-sm px-4"
													onChange={(e) => valueHandler(e)} />
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col">
											<div className="form-group">
												<label className="form-label">
													<span className="form_required">*</span>
													{t("page.phone")}
												</label>
												<input name="phone" value={formValues.phone}
													maxlength="12" className="form-control rounded-pill border-0 shadow-sm px-4"
													onChange={(e) => valueHandler(e)} />
											</div>
										</div>
										<div className="col">
											<div className="form-group">
												<label className="form-label">
													<span className="form_required">*</span>
													{t("page.country")}
												</label>
												<select name="countryCode"
													className="form-select form-select-sm"
													style={{ borderRadius: "5px" }}
													onChange={(e) => countryHandler(e)}
													value={countrySelected}>
													<option />
													{countries.map((country) => (
														(country.countryCode) &&
														<option value={country.countryCode}>
															{country.name}
														</option>
													))}
												</select>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col">
											<div className="form-group">
												<label className="form-label">
													{t("page.address1")}
												</label>
												<input name="address1" value={formValues.address1} maxlength="30"
													className="form-control rounded-pill border-0 shadow-sm px-4"
													onChange={(e) => valueHandler(e)} />
											</div>
										</div>
										<div className="col">
											<div className="form-group">
												<label className="form-label">
													{t("page.address2")}
												</label>
												<input name="address2" value={formValues.address2} maxlength="30"
													className="form-control rounded-pill border-0 shadow-sm px-4"
													onChange={(e) => valueHandler(e)} />
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col">
											<div className="form-group">
												<label className="form-label">
													{t("page.city")}
												</label>
												<input name="city" value={formValues.city} maxlength="30"
													className="form-control rounded-pill border-0 shadow-sm px-4"
													onChange={(e) => valueHandler(e)} />
											</div>
										</div>
										<div className="col">
											<div className="form-group">
												<label className="form-label">
													<span className="form_required">*</span>
													{t("page.state")}
												</label>
												<select name="stateKey"
													className="form-select form-select-sm"
													style={{ borderRadius: "5px" }}
													onChange={(e) => stateHandler(e)}
													value={stateValue}>
													<option />
													{states.map((state) => (
														(state.countryCode === countrySelected) &&
														<option value={state.stateKey + "-" + state.stateCode}>
															{state.name}
														</option>
													))}
												</select>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col">
											<div className="form-group">
												<label className="form-label">
													{t("page.zipCode")}
												</label><input name="zipCode" value={formValues.zipCode}
													maxlength="5"
													className="form-control rounded-pill border-0 shadow-sm px-4"
													onChange={(e) => valueHandler(e)} />
											</div>
										</div>
										<div className="col">
											<div className="form-group">
												<label className="form-label">
													{t("page.zipExt")}
												</label>
												<input name="zipExt" value={formValues.zipExt}
													maxlength="4"
													className="form-control rounded-pill border-0 shadow-sm px-4"
													onChange={(e) => valueHandler(e)} />
											</div>
										</div>
									</div>
									<div className="footer">
										<div id="submit-spinner"
											className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
										>  </div>
										<input
											type="submit"
											name="edit-submit"
											id="edit-submit"
											data-dismiss="modal"
											className="btn btn-primary btn-block"
											style={{ marginTop: "10px", marginBottom: "10px" }}
											value={submitText}
											disabled={isSubmit}
										>
										</input>

									</div>
								</form>
							</div>
						</div>
						<div className="row">
							<div className="col mt-3">
								{((formErrors && formErrors.length > 0) || error) && (
									<div id="berrorMessage" className="errorblock">
										{((formErrors && formErrors.length > 0) || error) ? (
											formErrors.map((errorData, index) => (
												<p className="message-line">{errorData}</p>
											))
										) : ""}
										{error}
									</div>
								)}
							</div>
						</div>
						<div className="row">
							<div className="col">
								<div id="placeholder_1" className="placeholder-pg" style={{ height: "10px" }}></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default Signup;